import {
  FlexContainer,
  FlexColumn,
} from '@editor/components/utilities/layouts';
import { H1, P1 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { HideMobile } from '../../utilities/queries';

export const Wrapper = styled(FlexContainer)`
  display: inline-flex;
  gap: 12px;
`;

export const ContentWrapper = styled(FlexColumn)`
  display: flex;
  width: 240px;
  padding-right: 48px;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
`;

export const Heading = styled(H1)`
  font-size: 36px;
  font-style: normal;
  font-weight: 800;
  line-height: 42px;
`;

export const Description = styled(P1)`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

export const ImageWrapper = styled(HideMobile)<{ background: string }>`
  width: 540px;
  height: 540px;
  background: ${({ background }): string => background};
  background-position: center;
  background-repeat: no-repeat;

  ${QUERIES.largeTabletAndUp} {
    display: flex; // Visible on tablets and up
  }
`;
